import type { EcommerceNewsItem } from '../mock/getMockNews';

import CheckIcon from '@/assets/icons/V3/CheckIcon.svg?react';
import type { HTMLReactParserOptions } from 'html-react-parser';
import parse, { domToReact } from 'html-react-parser';
import { convertAsteriskToStrong } from '@/utils/parser';
import { DotIcon } from 'lucide-react';

export const parsePoints = (html: string) => {
  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      if (domNode.name === 'strong') {
        return (
          <strong className="text-[14px] font-bold leading-[22px]">
            {domToReact(domNode.children)}
          </strong>
        );
      }
    },
  };

  return parse(html, options);
};

export const NewsSellerPoints = ({ sellerPoints }: Pick<EcommerceNewsItem, 'sellerPoints'>) => {
  const rawPoints = sellerPoints.map((point) => convertAsteriskToStrong(point));
  const parsedPoints = rawPoints.map((point) => parsePoints(point));

  return (
    <div className="flex flex-col gap-[2px] rounded-[12px] bg-gr-100 p-[12px]">
      <PointsHeader />
      <div className=" text-gr-700  Caption1M12">
        {parsedPoints.map((point, index) => (
          <div key={index} className="flex items-start">
            <DotIcon className="size-5 shrink-0" />
            <div className="break-words">{point}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const PointsHeader = () => {
  return (
    <div className="flex items-center gap-[4px]">
      <CheckIcon />
      <p className="text-gr-800 Body4S14">셀러 포인트 정리</p>
    </div>
  );
};
